import { render, staticRenderFns } from "./Project.vue?vue&type=template&id=5b6d7fcf&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"
import style0 from "./Project.vue?vue&type=style&index=0&id=5b6d7fcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6d7fcf",
  null
  
)

export default component.exports